import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchBodyEntriesArgs } from '../api/types/statsEntries.types';

import {
  fetchCircumference,
  fetchSkinfold,
  fetchInBody,
} from '../api/bodyStats.api';

export const statsBodyQueryKeys = createQueryKeys('statsBody', {
  fetchCircumference: (args: FetchBodyEntriesArgs = {}) => ({
    queryFn: () => fetchCircumference(args),
    queryKey: [args],
  }),
  fetchInBody: (args: FetchBodyEntriesArgs = {}) => ({
    queryFn: () => fetchInBody(args),
    queryKey: [args],
  }),
  fetchSkinfold: (args: FetchBodyEntriesArgs = {}) => ({
    queryFn: () => fetchSkinfold(args),
    queryKey: [args],
  }),
});
